import { useQuery, useMutation } from "@tanstack/react-query";
import { QueryModule } from "@/data/queryModules";
import { MutationEffectsOptions, useMutationEffects } from "@/data/useMutationEffects";
import { AppQueryOptions, AppMutationOptions } from "@povio/openapi-codegen-cli";
import { WorthDataApi } from "./worthData.api";

export namespace WorthDataQueries {

export const moduleName = QueryModule.WorthData;

export const keys = {
    all: [moduleName] as const,
    get: () => [...keys.all, "/worth-data", ] as const,
};




 /** 
 * Mutation `useCalculate`
 * @param { AppMutationOptions & MutationEffectsOptions } options Mutation options
 * @returns { UseMutationResult<void> } 
 * @statusCodes [204, 401]
 */
export const useCalculate = (options?: AppMutationOptions<typeof WorthDataApi.calculate, {  }> & MutationEffectsOptions) => {
  
  const { runMutationEffects } = useMutationEffects({ currentModule: moduleName });

  return useMutation({
    mutationFn: () => 
      
            WorthDataApi.calculate()
    ,
    ...options, 
    onSuccess: async (resData, variables, onMutateResult, context) => {
      await runMutationEffects(resData, options);
      options?.onSuccess?.(resData, variables, onMutateResult, context);
    },
  });
};





 /** 
 * Query `useGet`
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.WorthNumbersDto> } 
 * @statusCodes [200, 401]
 */
export const useGet = <TData>(options?: AppQueryOptions<typeof WorthDataApi.get, TData>) => {
  
  
  return useQuery({
    queryKey: keys.get(),
    queryFn: WorthDataApi.get
    ,
    ...options,
  });
};






}
